import React, { Component } from "react";
import { Switch, Route, BrowserRouter as Router, } from "react-router-dom";
import Cookies from 'universal-cookie';

// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Pages
import Home from "./pages/Home";
import HTFOnline from "./pages/HTFOnline";
import Home_Preview from "./pages/previews/Home_Preview";
import HTFOnline_Preview from "./pages/previews/HTFOnline_Preview";
import service from "./common/service"
import NotFound from "./pages/not-found";
import { connect } from 'react-redux'



export const AuthContext = React.createContext({});


let sub;
const cookies = new Cookies();
const mapStateToProps = state => ({
    CurrentUserData: state.CurrentUserData,
})

class Routers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSocketConnected: false,
			isAuthenticated: false,
			isLoading: true,
		};
		this.apiServe = new service();
	}

	componentWillMount = () => {
		this.apiServe.connect((flag) => {
			if (flag) {
				this.setState({ isSocketConnected: true }, () => {
					var token = localStorage.getItem("myLoginToken")
						? localStorage.getItem("myLoginToken")
						: "";
					let particularUser = cookies.get("SundanceNewUser") || cookies.get("particularNewUser");

					if (particularUser && particularUser.token) {
						this.apiServe.sendevent("authentication", {
							token: particularUser.token
						});
					}
					else {
						this.setState({ isLoading: false });
					}
				});
			}
		});
	};
	componentDidMount=()=> {
		this.apiServe.getevent().subscribe((response) => {
            switch (response.event) {
			case "authentication":
                    if(!response.error)
                    {
						this.apiServe.sendevent("user|getProfile", {});
                        this.setState({ isAuthenticated: true })
                    }
                    else
                    {
                    }
				break;
				case "user|getProfile":
					if (response.error) {
					  if (response.code === "401") {
						// this.props.history.push("/");
					  }
					//   this.openPopup("", [response.data.error], false);
					} else {
					this.props.dispatch({type: 'CurrentUserData', res: response.data})
					  let userInfo = {
						fname: response.data.fname,
						lname: response.data.lname,
						image: response.data.image,
						showMyLibrary:response.data.showMyLibrary && response.data.showMyLibrary
					  };
					  if(response.data.COMM_AGMT_FLAG === 'N'){
						window.open(process.env.REACT_APP_HOME_URL, '_self')
					  }
					  localStorage.setItem("Header", JSON.stringify(userInfo));
					  this.forceUpdate();
					}
					break;
			default:
				break;
			}
		})
	}
	render() {
		return (
			<>
				{/* <Router> */}
					{this.state.isSocketConnected && (
						<Switch>
							<Route exact path="/htf-online-preview"  render={(props) => <HTFOnline_Preview {...props} />} />
							<Route exact path="/htf-inperson-preview"  render={(props) => <Home_Preview {...props} />} />
							{/* <Route exact path="/:inperson?" component={Home} /> */}
							<Route exact path={`/online/:id?`} render={props => <HTFOnline key={props.match.params.id} {...props} />} />
							<Route exact path={`/inperson/:id?`} render={props => <Home key={props.match.params.id} {...props} />} />
							<Route exact path="/" component={HTFOnline} />
							<Route path="*" component={NotFound} />
						</Switch>
					)
					}
				{/* </Router> */}
			</>
		);
	}
}

export default connect(mapStateToProps, null)(Routers);
